<template>
  <div
    id="kt_header_mobile"
    class="header-mobile align-items-center"
    v-bind:class="headerClasses"
  >
    <!--begin::Header Menu Mobile Toggle-->
    <button
    v-if="authorize == 'supplier'"
      class="btn p-0 ml-4"
      id="kt_header_mobile_toggle"
      ref="kt_header_mobile_toggle"
    >
      <span class="grey--text">{{
        $store.getters.currentMerchantObject
          ? $store.getters.currentMerchantObject.name
          : 'کسب و کار خود را انتخاب کنید'
      }}</span>
      <v-icon> mdi mdi-chevron-down</v-icon>
    </button>
    <!--end::Header Menu Mobile Toggle-->
    <!--begin::Toolbar-->
    <div class="d-flex align-items-center">
      <!--begin::Aside Mobile Toggle-->
      <!-- 
        class="btn p-0 burger-icon burger-icon-left"

       -->
      <button
        v-if="asideEnabled"
        id="kt_aside_mobile_toggle"
        class="btn p-0 "
      >
        <!-- <span></span> -->
        <v-icon color="white">mdi mdi-menu</v-icon>
      </button>
      <!--end::Aside Mobile Toggle-->

      <!--begin::Topbar Mobile Toggle-->
      <button
        class="btn btn-hover-text-primary p-0 ml-2"
        id="kt_header_mobile_topbar_toggle"
        ref="kt_header_mobile_topbar_toggle"
      >
        <span class="svg-icon svg-icon-xl">
          <!--begin::Svg Icon | path:svg/icons/General/User.svg-->
          <inline-svg class="svg-icon" src="media/svg/icons/General/User.svg" />
          <!--end::Svg Icon-->
        </span>
      </button>
      
      <!--end::Topbar Mobile Toggle-->
    </div>
    <!--end::Toolbar-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import KTLayoutHeaderTopbar from '@/assets/js/layout/base/header-topbar.js';

export default {
  name: 'KTHeaderMobile',
  components: {},
  mounted() {
    // Init Header Topbar For Mobile Mode
    KTLayoutHeaderTopbar.init(this.$refs['kt_header_mobile_topbar_toggle']);
  },
  computed: {
    ...mapGetters(['layoutConfig', 'getClasses', 'authorize']),

    /**
     * Get header logo
     * @returns {string}
     */
    headerLogo() {
      return process.env.BASE_URL + this.layoutConfig('self.logo.dark');
    },

    /**
     * Get classes for mobile header
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses('header_mobile');
      if (typeof classes !== 'undefined') {
        return classes.join(' ');
      }
      return null;
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig('aside.self.display');
    },
  },
};
</script>
